import { Box, TextField, IconButton, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { TwitterIcon, InstagramIcon, FacebookIcon, LinkedinIcon } from 'assets'
import UploadLogo from './uploadLogoDialog'
import { useState } from 'react'
import api from 'api'
import routes from '../../api/routes'
import { useSelector } from 'react-redux'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'

const sx = {
  textBox: {
    '& .MuiInputBase-root': {
      caretColor: '#0A78CD',
      backgroundColor: '#fff !important',
    },
    '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #d3d3df',
    },
    '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #d3d3df',
    },
    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #0A78CD !important',
    },
  },
  arrow: {
    color: 'color.blue',
  },
  tooltip: {
    backgroundColor: 'color.blue',
  },
}

const SocialInput = ({ icon, data, onChange }) => {
  return (
    <Box width="47%" position="relative">
      <Box position="absolute" left="10px" zIndex={1} top="8px">
        {/* <img src={icon} alt="Social Icon" width="20px" /> */}
        {icon}
      </Box>
      <TextField
        sx={sx.textBox}
        defaultValue={data.userEnteredInformation}
        variant="outlined"
        onChange={e =>
          onChange(
            {
              ...data,
              userEnteredInformation: e.target.value,
            },
            'descriptiveInfoSocialMedia',
          )
        }
        InputLabelProps={{ shrink: false }}
        className="customInput bootstrapLabel customLabel"
        size="small"
        fullWidth
        placeholder="URL"
        inputProps={{
          style: {
            paddingLeft: '35px',
          },
        }}
      />
    </Box>
  )
}

const Placeholder = ({ title, body, tooltipContent }) => {
  const [open, setOpen] = useState(false)
  return (
    <Box marginBottom="40px">
      <Box display="flex" justifyContent="space-between">
        <Box
          width="100%"
          color="#25245F"
          fontSize="12px"
          fontWeight={600}
          textTransform="uppercase"
          borderBottom="1px solid #25245F"
          paddingBottom="5px"
        >
          {title}
        </Box>
        <Box>
          <Tooltip
            onClick={() => (!open ? setOpen(true) : setOpen(false))}
            onBlur={e => setOpen(false)}
            arrow
            open={open}
            componentsProps={{ tooltip: { sx: sx.tooltip }, arrow: { sx: sx.arrow } }}
            title={<Typography variant="body2">{tooltipContent}</Typography>}
          >
            <IconButton>
              <InfoOutlinedIcon fontSize="large" sx={{ color: '#0099FF' }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      {body}
    </Box>
  )
}

const CompanyInformation = ({ setDisable, descriptiveInfo, onChange }) => {
  const { descriptiveInfoSocialMedia, descriptiveInfoLogo, descriptiveInfoDescription } = descriptiveInfo
  const [uploadLogo, setUpload] = useState(false)
  const dashboardInfo = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const infos = dashboardInfo?.business_info?.claimed_business_details
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState(false)
  const [logoDetails, setLogoURL] = useState({
    name: 'C',
    URL: descriptiveInfoLogo[0].userEnteredInformation
      ? process.env['REACT_APP_BACKEND_BASE_AUTH_URL'] +
        '/static/images/business/' +
        descriptiveInfoLogo[0].userEnteredInformation
      : infos?.details?.photoFileId
      ? `${process.env['REACT_APP_BACKEND_BASE_AUTH_URL']}/static/images/business/${infos?.details?.photoFileId}`
      : infos?.web
      ? `//logo.clearbit.com/${infos?.details?.website || infos?.web}`
      : null,
    file: null,
  })
  const handleLogoSubmit = async image => {
    const formData = new FormData()
    formData.append('file', image)
    formData.append('business_id', dashboardInfo?.business_list[0]?.mkz_business_id)
    const bphotoId = await api.updateAvatar(formData, routes.businessAvatar)
    onChange(
      {
        userEnteredInformation: bphotoId?.fileId,
        label: 'BIZ_LOGO',
      },
      'descriptiveInfoLogo',
    )
    setLogoURL({
      name: image.name,
      URL: process.env['REACT_APP_BACKEND_BASE_AUTH_URL'] + '/static/images/business/' + bphotoId?.fileId,
      file: image,
    })
    setDisable(false)
  }
  const handleDeleteLogo = async e => {
    await api.deleteAvatar(routes.businessAvatarDel, { businessId: dashboardInfo?.business_list[0]?.mkz_business_id })
    setDisable(false)
    setLogoURL({
      name: logoDetails.name,
      URL: null,
      file: null,
    })
  }

  const socialIcons = [
    <TwitterIcon
      style={{
        transform: 'scale(0.85)',
      }}
    />,
    <LinkedinIcon
      style={{
        transform: 'scale(0.85)',
      }}
    />,
    <InstagramIcon
      style={{
        transform: 'scale(0.85)',
      }}
    />,
    <FacebookIcon
      style={{
        transform: 'scale(0.85)',
      }}
    />,
  ]
  return (
    <Box className="markaazCards" marginTop="30px" padding="30px" width="70%">
      <Placeholder
        title="Company description"
        tooltipContent="A Company Description is a summary of your business. It is used to describe the mission statement, key aspects and features of your business."
        body={
          <Box marginTop="20px">
            {descriptiveInfoDescription.map(val => {
              return (
                <TextField
                  multiline={6}
                  onChange={e =>
                    onChange(
                      {
                        ...val,
                        userEnteredInformation: e.target.value,
                      },
                      'descriptiveInfoDescription',
                    )
                  }
                  defaultValue={val.userEnteredInformation}
                  sx={sx.textBox}
                  maxRows={4}
                  variant="outlined"
                  InputLabelProps={{ shrink: false }}
                  className="customInput bootstrapLabel customLabel"
                  size="small"
                  fullWidth
                  placeholder="No data found"
                />
              )
            })}
          </Box>
        }
      />
      <Placeholder
        title="Company logo"
        tooltipContent="A visual reference for people to recognize your business. Logos are an important tool to establish a brand identity and make a strong and lasting impression that seperates your business from competitors."
        body={
          <Box marginTop="20px" width="200px" textAlign="center">
            {logoDetails.URL ? (
              <img
                alt="Logo Placeholder"
                src={logoDetails.URL}
                width="200"
                height="200"
                style={{
                  border: '1px solid #0099FF',
                  borderRadius: '10px',
                  objectFit: 'scale-down',
                }}
              />
            ) : (
              <Box
                height="200px"
                width="200px"
                border="1px solid #0099FF"
                borderRadius="10px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box fontSize="60px" fontWeight={600} color="#0099FF">
                  {dashboardInfo?.business_list[0]?.business_name
                    ? (dashboardInfo?.business_list[0]?.business_name).charAt(0).toUpperCase()
                    : '-'}
                </Box>
              </Box>
            )}
            {logoDetails.URL ? (
              <Box marginTop="8px" display="flex" justifyContent="space-between" alignItems="center">
                <Box
                  fontSize={12}
                  fontWeight={700}
                  color="#0A78CD"
                  onClick={() => setUpload(true)}
                  sx={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  Replace Logo
                </Box>
                <Box
                  fontSize={12}
                  fontWeight={700}
                  color="#D14343"
                  onClick={() => {
                    setDeleteConfirmDialog(true)
                  }}
                  sx={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  Delete
                </Box>
              </Box>
            ) : (
              <Box
                marginTop="5px"
                fontSize={12}
                fontWeight={700}
                color="#0A78CD"
                onClick={() => setUpload(true)}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Upload Logo
              </Box>
            )}
          </Box>
        }
      />
      {deleteConfirmDialog && (
        <ConfirmDialog
          show={setDeleteConfirmDialog}
          setShow={() => setDeleteConfirmDialog(false)}
          onSuccess={handleDeleteLogo}
          SuccessMessage="Delete"
          title="Are You Sure?"
          content="Do you want to proceed with removing the logo?"
        />
      )}
      <Placeholder
        title="Social media"
        tooltipContent="Link and promote your social media pages to other users of Markaaz."
        body={
          <Box
            marginTop="20px"
            display="flex"
            gap="30px"
            width="95%"
            paddingTop="10px"
            justifyContent="space-between"
            flexWrap="wrap"
          >
            {descriptiveInfoSocialMedia.map((val, i) => {
              return <SocialInput onChange={onChange} key={val.label} data={val} icon={socialIcons[i]} />
            })}
          </Box>
        }
      />
      {uploadLogo && (
        <UploadLogo open={uploadLogo} onSubmit={data => handleLogoSubmit(data)} onClose={() => setUpload(false)} />
      )}
    </Box>
  )
}

export default CompanyInformation
